import FilterContext from '@jetshop/core/components/Filters/FilterContext';
import get from 'lodash.get';
import qs from 'qs';
import * as React from 'react';
import FilterParams from './FilterParams';
import { formatFilter } from './utils/formatFilter';
import stripCategoryId from './utils/stripCategoryId';
let FilterContainer = /** @class */ (() => {
    class FilterContainer extends React.Component {
        constructor(props) {
            super(props);
            this.clearFilters = (args = {}) => this.clearAllFilters(args);
            this.filterChangeCallback = () => {
                this.props.onFilterChange &&
                    this.props.onFilterChange(this.state.activeFilters);
            };
            this.clearListFilter = (inputId, value) => {
                const id = stripCategoryId(inputId);
                const filterSet = this.state.activeFilters.listFilters.find(filter => filter.id === id);
                const withoutThisFilter = this.state.activeFilters.listFilters.filter(filter => filter.id !== id);
                const withThisFilterMutated = [
                    ...withoutThisFilter,
                    {
                        id,
                        values: [...filterSet.values.filter(filterVal => filterVal !== value)]
                    }
                ];
                const listFilters = filterSet.values.length === 1 ? withoutThisFilter : withThisFilterMutated;
                this.setState(state => {
                    return {
                        activeFilters: Object.assign(Object.assign({}, state.activeFilters), { listFilters }),
                        lastChangedFilterType: 'listFilters'
                    };
                }, this.filterChangeCallback);
            };
            this.clearAllFilters = ({ updateHistory = true, skipPersisted = false }) => {
                const { activeFilters } = this.state;
                const freshState = this.initialState;
                if (skipPersisted) {
                    // Add persisted filters back to state object
                    if (this.props.persistFiltersById.length > 0) {
                        const match = Object.keys(activeFilters)
                            .map(filterType => {
                            if (activeFilters[filterType].length === 0)
                                return false;
                            const match = activeFilters[filterType].filter((filter) => this.props.persistFiltersById.includes(filter.id));
                            return { [filterType]: match };
                        })
                            .filter(Boolean);
                        match.map(item => {
                            Object.assign(freshState.activeFilters, item);
                        });
                    }
                }
                this.setState(Object.assign(freshState, {
                    lastChangedFilterType: updateHistory ? 'all' : null,
                    filterLocation: this.props.location.pathname
                }), this.filterChangeCallback);
            };
            this.applyListFilter = (inputId, items) => {
                const id = stripCategoryId(inputId);
                const formatted = formatFilter.list({
                    list: { [id]: items.map(item => item.value) }
                });
                const filters = this.state.activeFilters.listFilters.filter(filter => filter.id !== id);
                this.setFilterState([...filters, ...formatted], 'listFilters');
            };
            this.applyRangeFilter = (inputId, min, max) => {
                const id = stripCategoryId(inputId);
                const formatted = formatFilter.range({
                    range: { [id]: [min, max] }
                });
                const filters = this.state.activeFilters.rangeFilters.filter(rangeFilter => rangeFilter.id !== id);
                this.setFilterState([...filters, ...formatted], 'rangeFilters');
            };
            this.applyMultiFilter = (inputId, item, index) => {
                const id = stripCategoryId(inputId);
                const activeMultiFilters = this.state.activeFilters.multiListFilters;
                // Finds any applied filters that share the same id
                const activeWithSameId = activeMultiFilters.find(multiFilter => multiFilter.id === id);
                let values = [];
                if (!activeWithSameId) {
                    // This filter set doesn't exist yet, so just add to the empty array
                    values = [item];
                }
                else {
                    // Clear applied filters after this level (index) by slicing them off the
                    // array
                    values = activeWithSameId.values.slice(0, index);
                    // Add the new item to the array if one was given. If one wasn't given,
                    // this must be a `clear filter` action
                    item && (values[index] = item);
                }
                const formatted = formatFilter.multiList({ multiList: { [id]: values } });
                this.setFilterState([
                    // All the other multiFilters that are applied
                    ...activeMultiFilters.filter(multiFilter => multiFilter.id !== id),
                    // Append this multiFilter filterSet, if it has any values
                    ...(values.length > 0 ? formatted : [])
                ], 'multiListFilters');
            };
            this.applyBoolFilter = (inputId, value) => {
                const id = stripCategoryId(inputId);
                const currentBooleanFilters = this.state.activeFilters.booleanFilters;
                let booleanFilters = [];
                if (!value) {
                    // If the value is false, remove it from the filterSet.
                    // For now we don't support negative filtering.
                    booleanFilters = [
                        ...currentBooleanFilters.filter(boolFilter => boolFilter.id !== id)
                    ];
                }
                else {
                    const formatted = formatFilter.boolean({ boolean: { [id]: [value] } });
                    booleanFilters = [
                        ...this.state.activeFilters.booleanFilters,
                        ...formatted
                    ];
                }
                this.setFilterState(booleanFilters, 'booleanFilters');
            };
            this.setFilterState = (newState, filterType) => {
                // Filter out options with empty values
                const filteredState = newState.filter(filter => !(filter.values && filter.values.length === 0));
                this.setState(state => {
                    return {
                        activeFilters: Object.assign(Object.assign({}, state.activeFilters), { [filterType]: filteredState }),
                        lastChangedFilterType: filterType,
                        filterLocation: this.props.location.pathname
                    };
                }, this.filterChangeCallback);
            };
            this.applyFilters = (activeFilters) => {
                const currentFilters = Object.assign({}, this.state.activeFilters);
                const keys = Object.keys(currentFilters);
                const newFilters = keys.reduce((filters, filterType) => {
                    // If filters were passed for this filterType, merge them with the active
                    // filters
                    if (activeFilters[filterType]) {
                        filters[filterType] = [
                            ...filters[filterType],
                            ...activeFilters[filterType]
                        ];
                    }
                    return filters;
                }, currentFilters);
                this.setState(() => {
                    return {
                        activeFilters: newFilters,
                        filterLocation: this.props.location.pathname
                    };
                }, this.filterChangeCallback);
            };
            console.warn('**** FilterContainer has been deprecated. This component will be removed in Flight 5.0.0. Docs describing the new filter implementation can be found at https://docs.dev.jetshop.se/filters');
            const state = this.initialState;
            if (props.defaultFilters) {
                Object.assign(state.activeFilters, props.defaultFilters);
            }
            this.state = state;
        }
        shouldComponentUpdate(nextProps, nextState) {
            if (nextProps.location.pathname !== this.props.location.pathname)
                return true;
            const filtersHaveChanged = Object.keys(this.state.activeFilters)
                .map(type => {
                return (this.state.activeFilters[type] !== nextState.activeFilters[type]);
            })
                .filter(Boolean).length > 0;
            if (filtersHaveChanged)
                return true;
            // If the page has changed
            if ((nextProps.location.search + this.props.location.search).match(/page=|pagenum=|term=/i)) {
                const currentQueryParams = qs.parse(this.props.location.search, {
                    ignoreQueryPrefix: true,
                    arrayLimit: 100
                });
                const nextQueryParams = qs.parse(nextProps.location.search, {
                    ignoreQueryPrefix: true,
                    arrayLimit: 100
                });
                if (currentQueryParams.page !== nextQueryParams.page)
                    return true;
                if (currentQueryParams.term !== nextQueryParams.term)
                    return true;
            }
            return false;
        }
        get initialState() {
            return {
                activeFilters: {
                    listFilters: [],
                    rangeFilters: [],
                    booleanFilters: [],
                    multiListFilters: []
                },
                applyListFilter: this.applyListFilter,
                clearListFilter: this.clearListFilter,
                applyMultiFilter: this.applyMultiFilter,
                applyBoolFilter: this.applyBoolFilter,
                applyRangeFilter: this.applyRangeFilter,
                clearFilters: this.clearFilters,
                applyFilters: this.applyFilters,
                // Used internally
                location: null,
                mounted: true
            };
        }
        componentDidUpdate() {
            /** First check if any filters are applied */
            const numberOfAppliedFilters = Object.keys(this.state.activeFilters).reduce((acc, curr) => {
                const length = this.state.activeFilters[curr].length;
                return acc + length;
            }, 0);
            // Check the state object from `this.props.location`. If we are at a Category
            // location and a different path to the lastFilterLocation, we should reset
            // filters
            const lastFilterLocation = this.state.filterLocation;
            const locationType = get(this.props.location.state, 'type');
            if (numberOfAppliedFilters > 0 &&
                locationType === 'Category' &&
                lastFilterLocation !== this.props.location.pathname) {
                // So, clear all filters (without pushing to history).
                this.clearAllFilters({ updateHistory: false, skipPersisted: true });
            }
        }
        render() {
            return (React.createElement(React.Fragment, null,
                !this.props.disableParamChange && (React.createElement(FilterParams, { activeFilters: this.state.activeFilters, lastChangedFilterType: this.state.lastChangedFilterType, applyFilters: this.applyFilters })),
                React.createElement(FilterContext.Provider, { value: this.state }, typeof this.props.children === 'function'
                    ? this.props.children(this.state)
                    : this.props.children)));
        }
    }
    FilterContainer.defaultProps = {
        persistFiltersById: [],
        disableParamChange: false
    };
    return FilterContainer;
})();
export { FilterContainer };
export default FilterContainer;
//# sourceMappingURL=FilterContainer.js.map